import { Button } from '@chakra-ui/react';
import { Temporal } from 'temporal-polyfill';

type TodayFloatingButtonProps = {
	/**
	 * The day where the user lives. Do not confuse with currentDay
	 */
	today: Temporal.PlainDate;
	days: Array<Temporal.PlainDate>;
	onTodayClick: () => void;
};

export default function TodayFloatingButton(props: TodayFloatingButtonProps) {
	if (isTodayInVisibleWeek(props.days, props.today)) {
		return null;
	}

	return (
		<Button
			variant="secondary"
			size="s"
			position="absolute"
			bottom="-52px"
			left="50%"
			transform="translateX(-50%)"
			borderRadius="radii-6"
			box-shadow="0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)"
			onClick={props.onTodayClick}
		>
			Today
		</Button>
	);
}

function isTodayInVisibleWeek(days: Array<Temporal.PlainDate>, today: Temporal.PlainDate) {
	return days.find((day) => day.equals(today));
}
